<template>
  <basic-container>
    <div style="display: flex">
      <div style="position: relative">
        <!-- <div class="d1"></div> -->

        <div id="pdf-content" class="prescription-container">
          <h1>{{ info.channel }}运动处方</h1>

          <table class="info-table" style="text-align: center">
            <tr>
              <td style="width: 25mm">姓名</td>
              <td style="width: 40mm">
                <input style="width: 35mm" v-model="info.name" />
              </td>
              <td style="width: 15mm">性别</td>
              <td style="width: 15mm">
                <input style="width: 15mm" v-model="info.gender" />
              </td>
              <td style="width: 15mm">年龄</td>
              <td style="width: 15mm">
                <input style="width: 15mm" v-model="info.age" />
              </td>
              <td style="width: 20mm">联系电话</td>
              <td>
                <input style="width: 25mm" v-model="info.mobile" />
              </td>
            </tr>
            <tr>
              <td style="width: 25mm">身份证</td>
              <td style="width: 40mm">
                <input style="width: 40mm" v-model="info.idCard" />
              </td>
              <td style="width: 15mm">病史</td>
              <td colspan="3" style="width: 45mm">
                <!-- {{ formData.medicalHistory }} -->
                <input style="width: 25mm" v-model="formData.medicalHistory" />
              </td>
              <td style="width: 20mm">使用药物</td>
              <td>
                <!-- {{ formData.medication }} -->
                <input style="width: 25mm" v-model="formData.medication" />
              </td>
            </tr>
          </table>

          <!-- 运动前筛查 -->
          <div class="model" style="">
            <h2>运动前筛查</h2>
            <table class="data-table" style="">
              <tr>
                <td style="width: 30mm; text-align: center">体力活动水平</td>
                <td>
                  <span style="margin-left: 10mm" @click="chickActivityLevel(1)">{{ formData.activityLevel == 1 ? '☑' : '☐' }} 不足</span>
                  <span style="margin-left: 15mm" @click="chickActivityLevel(2)">{{ formData.activityLevel == 2 ? '☑' : '☐' }} 一般</span>
                  <span style="margin-left: 15mm" @click="chickActivityLevel(3)">{{ formData.activityLevel == 3 ? '☑' : '☐' }} 正常</span>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div style="display: flex">
                    <div style="margin-left: 3mm; width: 22mm; font-weight: bold">健康筛查:</div>
                    <div style="margin-left: 0mm; width: 25mm; display: flex">
                      身高:
                      <input style="width: 8mm" v-model="info.height" />
                      cm
                    </div>
                    <div style="margin-left: 10mm; width: 25mm">
                      体重:
                      <input style="width: 8mm" v-model="info.weight" />
                      kg
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div style="display: flex; font-size: 14px">
                    <div style="margin-left: 25mm; width: 30mm">
                      空腹血糖:
                      <input style="width: 8mm" v-model="formData.bs" />
                    </div>
                    <div style="margin-left: 5mm; width: 30mm">
                      血压:
                      <input style="width: 15mm" v-model="formData.bp" />
                    </div>
                    <div style="margin-left: 5mm; width: 30mm">
                      脉搏:
                      <input style="width: 8mm" v-model="formData.hr" />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div style="display: flex">
                    <div style="margin-left: 25mm; width: 30mm">
                      总胆固醇:
                      <input style="width: 8mm" v-model="formData.cho" />
                    </div>
                    <div style="margin-left: 5mm; width: 30mm">
                      甘油三脂:
                      <input style="width: 8mm" v-model="formData.triglyceride" />
                    </div>
                    <div style="margin-left: 5mm; width: 35mm">
                      高密度脂蛋白:
                      <input style="width: 8mm" v-model="formData.slm1" />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div style="display: flex">
                    <div style="margin-left: 25mm; width: 25mm">
                      体脂率:
                      <input style="width: 10mm" v-model="formData.fat_rate" />
                    </div>
                    <div style="margin-left: 10mm; width: 30mm">
                      脂肪量:
                      <input style="width: 10mm" v-model="formData.fat" />
                    </div>
                    <div style="margin-left: 5mm; width: 30mm">
                      肌肉量：
                      <input style="width: 10mm" v-model="formData.slm" />
                    </div>
                    <div style="margin-left: 10mm; width: 35mm">
                      内脏脂肪面积
                      <input style="width: 10mm" v-model="formData.vfa" />
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <!-- 医学检查 -->
          <div class="model" style="">
            <h2>运动医学检查</h2>
            <table class="data-table" style="">
              <tr>
                <td style="width: 25mm; text-align: center">运动风险等级</td>
                <td colspan="2">
                  <span style="padding-left: 20mm" @click="ydfxdj(1)">{{ formData.ydfxdj == 1 ? '☑' : '☐' }} 低</span>
                  <span style="padding-left: 20mm" @click="ydfxdj(2)">{{ formData.ydfxdj == 2 ? '☑' : '☐' }} 中</span>
                  <span style="padding-left: 20mm" @click="ydfxdj(3)">{{ formData.ydfxdj == 3 ? '☑' : '☐' }} 高</span>
                </td>
              </tr>

              <tr>
                <td colspan="2" style="margin-left: 10mm">
                  <div style="display: flex">
                    <div style="margin-left: 3mm; width: 25mm; font-weight: bold">运动测试结果</div>
                  </div>
                </td>
              </tr>
              <tr style="width: 30mm">
                <td style="text-align: center">心肺功能</td>
                <td>
                  <div style="display: flex">
                    <div style="margin-left: 10mm; width: 12mm" @click="xfgn(1)">{{ formData.xfgn == 1 ? '■' : '☐' }} 差</div>
                    <div style="margin-left: 10mm; width: 12mm" @click="xfgn(2)">{{ formData.xfgn == 2 ? '■' : '☐' }} 较差</div>
                    <div style="margin-left: 10mm; width: 12mm" @click="xfgn(3)">{{ formData.xfgn == 3 ? '■' : '☐' }} 一般</div>
                    <div style="margin-left: 10mm; width: 12mm" @click="xfgn(4)">{{ formData.xfgn == 4 ? '■' : '☐' }} 良好</div>
                    <div style="margin-left: 10mm; width: 12mm" @click="xfgn(5)">{{ formData.xfgn == 5 ? '■' : '☐' }} 优秀</div>
                  </div>
                </td>
              </tr>
              <tr style="width: 30mm">
                <td style="text-align: center">肌肉力量</td>
                <td>
                  <div style="display: flex">
                    <div style="margin-left: 10mm; width: 12mm" @click="jrll(1)">{{ formData.jrll == 1 ? '■' : '☐' }} 差</div>
                    <div style="margin-left: 10mm; width: 12mm" @click="jrll(2)">{{ formData.jrll == 2 ? '■' : '☐' }} 较差</div>
                    <div style="margin-left: 10mm; width: 12mm" @click="jrll(3)">{{ formData.jrll == 3 ? '■' : '☐' }} 一般</div>
                    <div style="margin-left: 10mm; width: 12mm" @click="jrll(4)">{{ formData.jrll == 4 ? '■' : '☐' }} 良好</div>
                    <div style="margin-left: 10mm; width: 12mm" @click="jrll(5)">{{ formData.jrll == 5 ? '■' : '☐' }} 优秀</div>
                  </div>
                </td>
              </tr>
              <tr style="width: 30mm">
                <td style="text-align: center">体成分</td>
                <td>
                  <div style="display: flex">
                    <div style="margin-left: 10mm; width: 12mm" @click="tcf(1)">{{ formData.tcf == 1 ? '■' : '☐' }} 差</div>
                    <div style="margin-left: 10mm; width: 12mm" @click="tcf(2)">{{ formData.tcf == 2 ? '■' : '☐' }} 较差</div>
                    <div style="margin-left: 10mm; width: 12mm" @click="tcf(3)">{{ formData.tcf == 3 ? '■' : '☐' }} 一般</div>
                    <div style="margin-left: 10mm; width: 12mm" @click="tcf(4)">{{ formData.tcf == 4 ? '■' : '☐' }} 良好</div>
                    <div style="margin-left: 10mm; width: 12mm" @click="tcf(5)">{{ formData.tcf == 5 ? '■' : '☐' }} 优秀</div>
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <!-- 运动处方 -->
          <div class="model" style="">
            <h2>运动处方</h2>
            <table class="data-table" style="">
              <tr>
                <td style="width: 25mm; text-align: center">运动目的</td>
                <td colspan="7" style="font-size: 12px">
                  <span style="padding-left: 2mm" @click="ydmd(1)">{{ formData.jdxy == 1 ? '■' : '☐' }} 降低血压</span>
                  <span style="padding-left: 2mm" @click="ydmd(2)">{{ formData.tzxz == 1 ? '■' : '☐' }} 调整血脂</span>
                  <span style="padding-left: 2mm" @click="ydmd(3)">{{ formData.jdxt == 1 ? '■' : '☐' }} 降低血糖</span>
                  <span style="padding-left: 2mm" @click="ydmd(4)">{{ formData.jz == 1 ? '■' : '☐' }} 减重</span>
                  <span style="padding-left: 2mm" @click="ydmd(5)">{{ formData.zjxfnl == 1 ? '■' : '☐' }} 增加心肺耐力</span>
                  <span style="padding-left: 2mm" @click="ydmd(6)">{{ formData.zjjrll == 1 ? '■' : '☐' }} 增加肌肉力量</span>
                  <span style="padding-left: 2mm" @click="ydmd(7)">
                    {{ formData.zjstrrx == 1 ? '■' : '☐' }}
                    增加身体柔韧性
                  </span>
                </td>
              </tr>
              <tr>
                <td colspan="8">
                  <div style="display: flex">
                    <div style="margin-left: 3mm; font-weight: bold">机构运动项目</div>
                  </div>
                </td>
              </tr>
              <!-- <tr style="text-align: center">
                        <td style="width: 30mm; padding: 0">
                          <input style="width: 29mm" value="二头/三头肌训练" />
                        </td>
                        <td style="width: 10mm">
                          <input style="width: 10mm" value="1档" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="4组" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="21/组" />
                        </td>
                        <td style="width: 30mm">
                          <input style="width: 29mm" value="上推/下拉训练" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="2档" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="4组" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="24/组" />
                        </td>
                      </tr>
                      <tr style="text-align: center">
                        <td style="width: 30mm">
                          <input style="width: 29mm" value="推胸划船训练" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="3档" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="4组" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="23/组" />
                        </td>
                        <td style="width: 30mm">
                          <input style="width: 29mm" value="腹肌/背肌训练" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="3档" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="4组" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="20/组" />
                        </td>
                      </tr>
                      <tr style="text-align: center">
                        <td style="width: 30mm">
                          <input style="width: 29mm" value="大腿内外侧肌训练" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="2档" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="4组" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="20/组" />
                        </td>
                        <td style="width: 30mm">
                          <input style="width: 29mm" value="踢腿/勾腿训练" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="3档" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="4组" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" value="20/组" />
                        </td>
                      </tr> -->
              <tr style="text-align: center" v-for="index in 2" :key="index">
                <td style="width: 55mm" colspan="2">
                  <input style="width: 55mm" v-model="mechanismMotion[index * 2 - 2]" />
                </td>
                <!-- <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td> -->
                <td style="width: 15mm">
                  <input style="width: 14mm" />
                </td>
                <td style="width: 15mm">
                  <input style="width: 14mm" />
                </td>
                <td style="width: 55mm" colspan="2">
                  <input style="width: 55mm" v-model="mechanismMotion[index * 2 - 1]" />
                </td>
                <!-- <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td> -->
                <td style="width: 15mm">
                  <input style="width: 14mm" />
                </td>
                <td style="width: 15mm">
                  <input style="width: 14mm" />
                </td>
              </tr>
              <!-- <tr style="text-align: center">
                        <td style="width: 30mm">
                          <input style="width: 29mm" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td>
                        <td style="width: 30mm">
                          <input style="width: 29mm" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td>
                      </tr> -->
              <tr>
                <td colspan="8">
                  <div style="display: flex">
                    <div style="margin-left: 3mm; font-weight: bold">居家运动项目</div>
                  </div>
                </td>
              </tr>

              <tr style="text-align: center" v-for="index in 3" :key="index">
                <td style="width: 30mm">
                  <input style="width: 29mm" v-model="homeMotion[index * 2 - 2]" />
                </td>
                <td style="width: 15mm">
                  <input style="width: 14mm" v-model="group[index * 2 - 2]" />
                </td>
                <td style="width: 15mm">
                  <input style="width: 14mm" v-model="num[index * 2 - 2]" />
                </td>
                <td style="width: 15mm">
                  <input style="width: 14mm" />
                </td>
                <td style="width: 30mm">
                  <input style="width: 29mm" v-model="homeMotion[index * 2 - 1]" />
                </td>
                <td style="width: 15mm">
                  <input style="width: 14mm" v-model="group[index * 2 - 1]" />
                </td>
                <td style="width: 15mm">
                  <input style="width: 14mm" v-model="num[index * 2 - 1]" />
                </td>
                <td style="width: 15mm">
                  <input style="width: 14mm" />
                </td>
              </tr>
              <!-- <tr style="text-align: center">
                        <td style="width: 30mm">
                          <input style="width: 29mm" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td>
                        <td style="width: 30mm">
                          <input style="width: 29mm" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td>
                      </tr> -->

              <tr>
                <td colspan="8">
                  <div style="display: flex">
                    <div style="margin-left: 3mm; font-weight: bold">运动计划</div>
                  </div>
                </td>
              </tr>
              <tr class="plan" style="text-align: center">
                <td style="width: 30mm">适应期</td>
                <td colspan="7">
                  目标能耗:
                  <input style="width: 20mm" v-model="adapt.energyConsumption" />
                  <br />
                  运动时间:
                  <input style="width: 25mm" v-model="adapt.time" />
                  运动频率:
                  <input style="width: 50mm" v-model="adapt.frequency" />
                </td>
              </tr>
              <tr class="plan" style="text-align: center">
                <td style="width: 30mm">强化期</td>
                <td colspan="7">
                  目标能耗:
                  <input style="width: 20mm" v-model="reinforcement.energyConsumption" />
                  <br />
                  运动时间:
                  <input style="width: 25mm" v-model="reinforcement.time" />
                  运动频率:
                  <input style="width: 50mm" v-model="reinforcement.frequency" />
                </td>
              </tr>
              <tr class="plan" style="text-align: center">
                <td style="width: 30mm">稳定期</td>
                <td colspan="7">
                  目标能耗:
                  <input style="width: 20mm" v-model="stable.energyConsumption" />
                  <br />
                  运动时间:
                  <input style="width: 25mm" v-model="stable.time" />
                  运动频率:
                  <input style="min-width: 50mm" v-model="stable.frequency" />
                </td>
              </tr>
              <tr style="text-align: left">
                <td colspan="8">
                  <div>
                    <div style="margin: 0 5mm" v-for="index in 3" :key="index">
                      {{ schemeExercise.specialNotes[index - 1] }}
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <!-- 签名 -->
          <div class="signature">
            <!-- <p>运动处方师: {{ formData.doctor }}</p> -->
            <p>
              运动处方师:
              <input v-model="formData.doctor" style="width: 25mm; border: 0px; text-align: left" />
            </p>
            <p style="margin-right: 0mm">
              回访时间:
              <input v-model="formData.followUpDate" style="width: 30mm; border: 0px; text-align: left" />
            </p>
          </div>
        </div>
      </div>
      <div class="pdf-options">
        <el-form label-width="120px">
          <el-form-item label="文件名称">
            <el-input v-model="pdfOptions.filename" placeholder="请输入文件名称"></el-input>
          </el-form-item>
          <el-form-item label="页面方向">
            <el-radio-group v-model="pdfOptions.jsPDF.orientation">
              <el-radio label="portrait">纵向</el-radio>
              <!-- <el-radio label="landscape">横向</el-radio> -->
            </el-radio-group>
          </el-form-item>
          <el-form-item label="页面尺寸">
            <el-select v-model="pdfOptions.jsPDF.format" placeholder="请选择页面尺寸">
              <el-option label="A4 (210×297mm)" value="a4"></el-option>
              <!-- <el-option label="A5 (148×210mm)" value="a5"></el-option>
                <el-option label="Letter (216×279mm)" value="letter"></el-option>
                <el-option label="自定义" value="custom"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="边距(mm)" v-if="pdfOptions.jsPDF.format === 'custom'">
            <el-input-number v-model="pdfOptions.margin" :min="0" :max="50"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer" style="float: right">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="generatePDF">生成PDF</el-button>
        </span>
      </div>
    </div>
  </basic-container>
</template>

<script>
import { getMotion, getBodyDate, getUserJkDetail, getExerciseSchemeNew, getExercisePrescription } from '@/api/health/manage'
// import { mapGetters } from "vuex";
import html2pdf from 'html2pdf.js'

export default {
  name: 'MotionUser',
  data() {
    return {
      wxUserId: this.$route.query.wxUserId,
      info: {},
      form: {},
      schemeExercise: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      data: [],
      showDialog: false, // 控制弹框显示
      dialogVisible: false,
      formData: {
        // name: "",
        // gender: "女",
        // age: 43,
        // phone: "153****8212",
        // idNumber: "320111198202*****",
        medicalHistory: '无疾病',
        medication: '',

        height: 162,
        weight: 86.9,
        activityLevel: 0,
        ydfxdj: 0,
        xfgn: 0,
        jrll: 0,
        tcf: 0,
        jdxt: 0,
        tzxz: 0,
        jdxy: 0,
        jz: 0,
        zjxfnl: 0,
        zjjrll: 0,
        zjstrrx: 0,
        jgydxm: 3,
        exercisePurposes: ['降低血压', '调整血脂', '降低血糖', '减重', '增加心肺活力'],
        institutionExercises: [
          {
            name: '二头/三头肌训练',
            level: '1档',
            sets: '4组',
            reps: '21个/组'
          },
          {
            name: '水瓶直筒侧平举',
            level: '2档',
            sets: '4组',
            reps: '24个/组'
          }
        ],
        notes: ['饭前饭后1小时内尽量不要运动', '锻炼后不应立即入浴、大汗淋漓时通低温，会使皮肤表层收缩，严重时引起闭汗症或静脉曲张'],
        doctor: '',
        followUpDate: new Date().toLocaleDateString()
      },
      pdfOptions: {
        margin: 10,
        filename: '运动处方.pdf',
        image: {
          type: 'jpeg',
          quality: 0.98
        },
        html2canvas: {
          scale: 2,
          useCORS: true
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait'
        }
      },
      weekTap: 1,
      chuFshow: 1,
      exerciseInfo: [],
      exercisePrescription: {},
      homeMotion: ['', '', '', '', '', '', '', '', ''],
      group: ['', '', '', '', '', '', '', '', ''],
      num: ['', '', '', '', '', '', '', '', ''],
      mechanismMotion: ['', '', '', '', '', '', '', '', ''],
      adapt: {},
      reinforcement: {},
      stable: {},
      specialNotes: ['', '', '', '', '', '', '', '', ''],
      sportsPurposes: []
    }
  },
  computed: {},
  created() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      const wxUserId = this.$route.query.wxUserId
      this.formData.followUpDate = new Date(new Date().setMonth(new Date().getMonth() + 3)).toLocaleDateString()

      getMotion(wxUserId).then(res => {
        this.data = res.data
        this.pdfOptions.filename = '运动处方_' + res.data[0].name
        this.formData.name = res.data[0].name
        this.formData.age = res.data[0].age
        if (res.data[0].sex === 2) this.formData.gender = '女'
        else if (res.data[0].sex === 1) this.formData.gender = '男'
        this.formData.phone = res.data[0].mobile
        this.formData.idNumber = res.data[0].id_card
        this.formData.height = res.data[0].height
        this.formData.weight = res.data[0].weight
      })

      getBodyDate(wxUserId).then(res => {
        this.body = res.data.medicalExaminationReport
      })

      getUserJkDetail(wxUserId).then(res => {
        this.info = res.data.userJk
        if (this.info.sex === 1) this.info.gender = '男'
        else if (this.info.sex === 2) this.info.gender = '女'
      })

      getExerciseSchemeNew(wxUserId).then(res => {
        this.schemeExercise = res.data
        const exerciseInfo = [
          { name: '运动类型', value: this.schemeExercise.schemeExerciseNew.sevenExerciseType },
          { name: '推荐项目', value: this.schemeExercise.schemeExerciseNew.sevenExerciseRecommend }
        ]
        this.exerciseInfo = exerciseInfo
        this.weekTap = '日'
      })

      getExercisePrescription(wxUserId).then(res => {
        console.log('getExercisePrescription', res.data)
        const formData = this.formData
        const exercisePrescription = res.data
        formData.bs = exercisePrescription.bs || ''
        formData.bp = exercisePrescription.bp || ''
        formData.hr = exercisePrescription.hr || ''
        formData.cho = exercisePrescription.cho || ''
        formData.fat_rate = exercisePrescription.fat_rate || ''
        formData.fat = exercisePrescription.fat || ''
        formData.slm = exercisePrescription.slm || ''
        formData.vfa = exercisePrescription.vfa || ''
        for (let i = 0; i < exercisePrescription.homeMotion.length; i++) this.homeMotion[i] = exercisePrescription.homeMotion[i]
        for (let i = 0; i < exercisePrescription.homeMotion.length; i++) this.mechanismMotion[i] = exercisePrescription.mechanismMotion[i]
        this.adapt = exercisePrescription.adapt || ''
        this.reinforcement = exercisePrescription.reinforcement || ''
        this.stable = exercisePrescription.stable || ''
        this.specialNotes = exercisePrescription.specialNotes || ''
        this.sportsPurposes = exercisePrescription.sportsPurposes || ''
        formData.ydfxdj = exercisePrescription.riskLevel
        console.log(res.data)
        console.log('riskLevel: ', exercisePrescription.riskLevel)
        this.formData = formData
      })
    },

    chickActivityLevel(index) {
      this.formData.activityLevel = Number(index)
    },

    ydfxdj(index) {
      this.formData.ydfxdj = Number(index)
    },

    xfgn(index) {
      this.formData.xfgn = Number(index)
    },

    jrll(index) {
      this.formData.jrll = Number(index)
    },

    tcf(index) {
      this.formData.tcf = Number(index)
    },

    ydmd(index) {
      index = Number(index)
      switch (index) {
        case 1:
          if (this.formData.jdxy === 1) this.formData.jdxy = 0
          else this.formData.jdxy = 1
          break
        case 2:
          if (this.formData.tzxz === 1) this.formData.tzxz = 0
          else this.formData.tzxz = 1
          break
        case 3:
          if (this.formData.jdxt === 1) this.formData.jdxt = 0
          else this.formData.jdxt = 1
          break
        case 4:
          if (this.formData.jz === 1) this.formData.jz = 0
          else this.formData.jz = 1
          break
        case 5:
          if (this.formData.zjxfnl === 1) this.formData.zjxfnl = 0
          else this.formData.zjxfnl = 1
          break
        case 6:
          if (this.formData.zjjrll === 1) this.formData.zjjrll = 0
          else this.formData.zjjrll = 1
          break
        case 7:
          if (this.formData.zjstrrx === 1) this.formData.zjstrrx = 0
          else this.formData.zjstrrx = 1
          break
      }
    },

    jgydxm(index) {
      this.formData.jgydxm = Number(index)
    },

    generatePDF() {
      this.showDialog = false // 关闭弹框
      const element = document.getElementById('pdf-content')

      const opt = {
        margin: 0,
        filename: this.pdfOptions.filename,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      }

      html2pdf().from(element).set(opt).save()
    },

    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
/* 重置所有继承属性 */
.style-isolation {
  all: initial;
}

/* 重置内部所有元素 */
.style-isolation * {
  all: unset;
}

.tr {
  vertical-align: middle;
  display: table-row;
  vertical-align: inherit;
  unicode-bidi: isolate;
  border-color: inherit;
}

.my-dialog-class {
  display: flex;
  align-items: flex-start;
}

.prescription-container {
  /* font-family: "SimSun", "宋体", serif; */
  width: 210mm;
  height: 296mm;
  padding: 0mm 10mm;
  box-sizing: border-box;
  float: left;
  font-family: Segoe UI, PingFang SC, Microsoft YaHei, sans-serif;
  border: 1px solid #000;
  line-height: 1.4;

  /* 防止PDF白条的关键属性 */
  border-collapse: separate !important;
  border-spacing: 0 !important;
  background: transparent !important;
  overflow: visible !important;
  position: relative !important;
  z-index: 1 !important;
}

input {
  border: 0px;
  line-height: 1.5;
  text-align: center;
}

.pdf-options {
  padding-left: 2%;
  float: left;
  width: 100mm;
}

h1 {
  text-align: center;
  font-size: 24px;
  /* margin-bottom: 20px; */
  color: #0066cc;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0px;
}

.info-table td {
  border: 1px solid #000;
  padding: 1mm;
  font-size: 14px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0px;
}

.data-table td {
  border: 1px solid #000;
  padding: 1mm;
  font-size: 13px;
}

.model {
  margin-bottom: 0px;
}

h2 {
  font-size: 16px;
  color: #0066cc;
  border-bottom: 1px solid #e0e0e0;
  box-sizing: border-box;
}

h3 {
  font-size: 18px;
  margin: 10px 0;
  border-bottom: 1px solid #000;
  padding-bottom: 5px;
}

ul,
ol {
  margin-left: 20px;
}

.signature {
  text-align: right;
}

p {
  margin-bottom: 0px;
  /* line-height: 1.7; */
}

template {
  all: initial;
}

.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 1px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
}
</style>
